<template>
    <div id="wrap" >
        <ul>
            <li v-for="(banner, index) in photos" :key="index" :class="{ on: index === currentIndex }">
                <img :src="banner.photo_link" :alt="index" class="block h-56 w-full object-fill">
            </li>
        </ul>
    
    </div>

</template>

<script>
    let timer = null;
    const AUTO_INTERVAL = 2000;
    export default {
        name: "slider",
        props: {photos: Array},
        data: function(){
            return {
                playing: false,
                currentIndex: 0
            }
        },
        methods: {
            setAutoRoll() {
                let vueSelf = this;
                timer = setInterval(function() {
                    vueSelf.addIndex();
                }, AUTO_INTERVAL);
            },
            addIndex() {
                let newIndex = this.currentIndex + 1;
                this.currentIndex = newIndex === this.photos?.length ? 0 : newIndex;
            },
            roll(direction) {
                let diff = direction === "prev" ? -1 : 1;
                this.currentIndex = this.getTargetIndex(diff);
                if(this.playing) {
                    clearInterval(timer);
                    this.setAutoRoll();
                }
            },
            play() {
                this.setAutoRoll();
                this.playing = true;
            },

            getTargetIndex(diff) {
                let length = this.photos.length;
                let index = this.currentIndex + diff;
                if (index === -1) {
                    return length - 1;
                }
                if (index === length) {
                    return 0;
                }
                return index;
            }
        },

        created() {
            this.play();
        }

    }
</script>

<style scoped>


    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
    li {
        display: none;
    }
    li.on {
        display: block;
    }

</style>
